import React, { useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'
import Carousel from 'react-multi-carousel';
import { FormattedMessage } from 'react-intl';
import { ANDROID_PLAY_STORE_URL, APP_REDIRECT_PATH, IOS_APP_STORE_URL } from '../../utils/openInApp';

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1200 },
        items: 3,
        slidesToSlide: 3 // optional, default to 1.
    },
    // 1025-1199 arasinda 3 kart sigmiyor: kart ~330px'e dusuyor ve uzun isimler (SE-EM Elektrotechnik GmbH)
    // 2 satira sarip yildiz/yorum hizasini bozuyordu. Bu bantta 2 kart gosteriyoruz.
    laptop: {
        breakpoint: { max: 1199, min: 1025 },
        items: 2,
        slidesToSlide: 2
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};

const TESTIMONALS = [
    {
        image: "/assets/images/testimonial-user-1.png",
        name: <FormattedMessage id="testimonials_1_name" />,
        title: <FormattedMessage id="testimonials_1_profession" />,
        point: 5,
        comment: <FormattedMessage id="testimonials_1_comment" />
    },
    {
        image: "/assets/images/testimonial-user-2.png",
        name: <FormattedMessage id="testimonials_2_name" />,
        title: <FormattedMessage id="testimonials_2_profession" />,
        point: 4,
        comment: <FormattedMessage id="testimonials_2_comment" />
    },
    {
        image: "/assets/images/testimonial-user-3.png",
        name: <FormattedMessage id="testimonials_3_name" />,
        title: <FormattedMessage id="testimonials_3_profession" />,
        point: 5,
        comment: <FormattedMessage id="testimonials_3_comment" />
    },
    {
        image: "/assets/images/testimonial-user-4.png",
        name: <FormattedMessage id="testimonials_4_name" />,
        title: <FormattedMessage id="testimonials_4_profession" />,
        point: 5,
        comment: <FormattedMessage id="testimonials_4_comment" />
    },
    {
        image: "/assets/images/testimonial-user-5.png",
        name: <FormattedMessage id="testimonials_5_name" />,
        title: <FormattedMessage id="testimonials_5_profession" />,
        point: 4,
        comment: <FormattedMessage id="testimonials_5_comment" />
    }
]

function MainPage() {
    const isXL = useMediaQuery({ query: '(min-width: 1824px)' });
    const isLG = useMediaQuery({ query: '(min-width: 1224px)' }) && !isXL;
    const isMD = useMediaQuery({ query: '(min-width: 768px)' }) && !isLG && !isXL;
    const isSM = useMediaQuery({ query: '(min-width: 425px)' }) && !isMD && !isLG && !isXL;
    const isXS = useMediaQuery({ query: '(max-width: 425px)' });

    //scroll to top on opening the page
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    padding: "97px 0 97px 0",
                    backgroundImage: "url('assets/images/background.png')",
                    backgroundRepeat: "no-repeat",
                    backgroundAttachment: "fixed",
                    backgroundSize: "cover",
                }}>
                <div style={{ color: "white", width: isXL ? "35%" : isLG ? "45%" : isMD ? "55%" : isSM ? "65%" : "75%" }}>
                    <p style={{ fontSize: "13px", margin: 0, letterSpacing: "1.63px" }}>
                        <FormattedMessage id="from_professionals" />
                    </p>
                    <p style={{ fontSize: "48px", fontWeight: 900, marginTop: "17px", marginBottom: "23px" }}>
                        <FormattedMessage id="home_title" />
                    </p>
                    <p style={{ fontSize: "20px", margin: 0 }}>
                        <FormattedMessage id="home_description" />
                    </p>
                    <div style={{
                        display: "flex",
                        ...(isXL || isLG || isMD) ? { flexDirection: "row" } : { flexDirection: "column" },
                        alignItems: "center",
                        gap: "15px",
                        marginTop: "61px"
                    }}>
                        <a href={ANDROID_PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="Google Play">
                            <img src="/assets/images/google-play-store-badge.png" alt="google-play-store-badge" style={{ height: "50px", objectFit: "contain", cursor: "pointer" }} />
                        </a>
                        <a href={IOS_APP_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="App Store">
                            <img src="/assets/images/app-store-badge.png" alt="app-store-badge" style={{ height: "50px", objectFit: "contain", cursor: "pointer" }} />
                        </a>
                        {/* QR https://owajoo.com/app adresini tasiyor; tiklayanlar da ayni yere gitsin. */}
                        <a href={APP_REDIRECT_PATH} aria-label="owajoo app">
                            <img src="/assets/images/qr.png" alt="qr" style={{ height: "75px", objectFit: "contain", borderRadius: "10px", cursor: "pointer" }} />
                        </a>
                    </div>
                </div>
                {(isXL || isLG || isMD) && <img src="/assets/images/inapp-screen-shoot-v3.png" alt="service-provider-screen-in-app" height={isMD ? "351px" : "551px"} />}
            </div>
            <div id='features' style={{ paddingTop: "100px", paddingBottom: "100px", display: "flex", flexDirection: "column", alignItems: "center", gap: "32px" }}>
                <h2 style={{ textAlign: "center", fontSize: "28px", fontWeight: 700, color: "#212121", margin: 0 }}>
                    <FormattedMessage id="highlight_features" />
                </h2>
                <div style={{ width: "80px", height: "3px", backgroundColor: "#000000", opacity: "90%" }} />
                <div style={{ display: "flex", flexDirection: (isXL || isLG || isMD) ? "row" : "column", justifyContent: "center", alignItems: "start", gap: "80px", marginTop: "20px" }}>
                    <HighlightFeature image="/assets/images/feature-1.png" title={<FormattedMessage id='highlight_feature_1_title' />} description={<FormattedMessage id='highlight_feature_1_description' />} />
                    <HighlightFeature image="/assets/images/feature-2.png" title={<FormattedMessage id='highlight_feature_2_title' />} description={<FormattedMessage id='highlight_feature_2_description' />} />
                    <HighlightFeature image="/assets/images/feature-3.png" title={<FormattedMessage id='highlight_feature_3_title' />} description={<FormattedMessage id='highlight_feature_3_description' />} />
                </div>
            </div>
            <div id='testimonials' style={{ paddingTop: "100px", paddingBottom: "100px", display: "flex", flexDirection: "column", alignItems: "center", gap: "32px", background: "#f3f3f3" }}>
                <h2 style={{ textAlign: "center", fontSize: "28px", fontWeight: 700, color: "#212121", margin: 0 }}>
                    <FormattedMessage id="testimonials" />
                </h2>
                <div style={{ width: "80px", height: "3px", backgroundColor: "#000000", opacity: "90%" }} />
                <div style={{ marginTop: "20px" }}>
                    <Carousel
                        responsive={responsive}
                        containerClass='carousel-container'
                        itemClass='carousel-item'
                        autoPlay
                        autoPlaySpeed={5000}
                        infinite
                        pauseOnHover
                        dotListClass='react-multi-carousel-list'
                        renderButtonGroupOutside
                    >
                        {TESTIMONALS.map((testimonial, index) => <Testimonal key={index} {...testimonial} />)}
                    </Carousel>
                </div>

            </div>
        </div>
    )
}

function HighlightFeature({ image, title, description }) {
    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", maxWidth: "350px" }}>
            <img src={image} alt={title} style={{ height: "200px", width: "200px", objectPosition: "top center", objectFit: "cover", borderRadius: "10px" }} />
            <h3 style={{ fontSize: "22px", fontWeight: 700, color: "#000000", marginTop: "30px 0 0 0" }}>{title}</h3>
            <p style={{ fontSize: "16px", color: "#000000", textAlign: "center", margin: 0 }}>{description}</p>
        </div>
    )
}

function Testimonal({ image, name, title, point = 5, comment }) {
    // <=1024px'te carousel tek kart gosteriyor ve kart 370px'e dusuyor. Logolar farkli genislikte
    // (en genisi SE-EM: 80px yukseklikte 127px) ve en uzun isim de o kartta — isme tam 201px kaliyordu,
    // yani sifir pay. Dar ekranda logoyu 64px'e cekince isim rahat tek satira sigiyor.
    const isNarrow = useMediaQuery({ query: '(max-width: 1024px)' });
    const logoHeight = isNarrow ? "64px" : "80px";

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            // alignItems: center -> stretch. center iken basliktaki logo+isim satiri shrink-to-fit olup metin
            // kolonunu min-content'e (yildiz satiri ~135px) daraltiyor ve uzun isimler 2 satira sariyordu.
            // stretch ile her iki satir da kart genisligine yaslanir: kolon ihtiyaci kadar genisler ve
            // logo, alttaki yorumun tirnak isaretiyle ayni sol kenardan baslar.
            alignItems: "stretch",
            gap: "10px",
            // Icerik artik ortalanmadigi (stretch) icin sol padding sart: aksi halde logo ve yorum
            // mobilde ekranin sol kenarina yapisiyor. Sag padding ayni zamanda 3'lu gorunumde
            // kartlar arasi bosluk gorevi goruyor.
            padding: "0 16px",
        }}>
            <div style={{ display: "flex", justifyContent: "start", alignItems: "start", gap: "10px" }}>
                <img src={image} alt={name} style={{ height: logoHeight, objectFit: "contain", borderRadius: "12px" }} />
                <div>
                    <p style={{ fontSize: "16px", fontWeight: 500, color: "#2D2E2E", margin: 0, lineHeight: "20px" }}>{name}</p>
                    <p style={{ fontSize: "12px", fontWeight: 500, color: "#ABABAB", margin: "4px 0 0 0", lineHeight: "16px" }}>{title}</p>
                    <div style={{ display: "flex", gap: "5px", marginTop: "12px" }}>
                        {Array.from({ length: point }, (_, index) => <img key={index} src="/assets/images/star.png" alt="star" style={{ height: "24px", objectFit: "contain" }} />)}
                        {Array.from({ length: 5 - point }, (_, index) => <div key={index} style={{ width: "24px", height: "24px" }} />)}
                    </div>
                </div>
            </div>
            <div style={{ display: "flex", justifyContent: "start", alignItems: "start", gap: "16px", marginTop: "24px" }}>
                <img src="/assets/images/testimonial-quotation-mark.png" alt="testimonial-quotation-mark" style={{ height: "24px", objectFit: "contain" }} />
                <p style={{ fontSize: "16px", color: "#2D2E2E", fontWeight: 500, margin: 0 }}>{comment}</p>
            </div>
        </div>
    )
}

export default MainPage